import { AutoSizer } from "react-virtualized";
import { FixedSizeList } from "react-window";
import EmptyPlaceholder from "components/EmptyPlaceholder/EmptyPlaceholder";
import WorkOrderCard from "./WorkOrderCard";

const WorkorderList = ({ entities, showActions = true, loadsOnly }) => {

    const Row = ({ index, style }) => (
        <div style={style}>
            <WorkOrderCard
                entity={entities?.[index]}
                handleDone={() => { }}
                key={index}
                showActions={showActions}
            />
        </div>
    );

    return <>
        {!!entities?.length ?
            <div style={{ flex: 1, marginRight: '1rem' }}>
                <AutoSizer>
                    {({ height, width }) => (
                        <FixedSizeList
                            className="List"
                            height={height + 190}
                            itemCount={entities?.length}
                            itemSize={130}
                            width={width - 10}
                        >
                            {Row}
                        </FixedSizeList>
                    )}
                </AutoSizer>
            </div>
            : <EmptyPlaceholder text={`There are no ${loadsOnly ? 'transports' : 'activities'} matching this criteria`} />
        }
    </>
}
export default WorkorderList;